import React from 'react'
import { Box, Chip } from '@mui/material'
import { useTheme } from '@mui/material/styles'

export type ScopeType = 'my' | 'all'

interface ToggleBadgesProps {
  title: string
  selectedScope: ScopeType
  onScopeChange: (scope: ScopeType) => void
}

const ToggleBadges: React.FC<ToggleBadgesProps> = ({ title, selectedScope, onScopeChange }) => {
  const theme = useTheme()

  const titleWithoutCount = title.replace(/\s*\([^)]*\)\s*$/, '').trim()

  return (
    <Box display="flex" gap={theme.spacing(3)} alignItems="center" flexDirection={{ xs: 'column', lg: 'row' }}>
      <Chip
        label={`My ${titleWithoutCount}`}
        color={selectedScope === 'my' ? 'primary' : 'default'}
        variant={selectedScope === 'my' ? 'filled' : 'outlined'}
        onClick={() => { onScopeChange('my') }}
        size="small"
        sx={{
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: 500,
          borderRadius: 1.5,
          '&:hover': {
            opacity: 0.8
          }
        }}
      />
      <Chip
        label={`All ${titleWithoutCount}`}
        color={selectedScope === 'all' ? 'primary' : 'default'}
        variant={selectedScope === 'all' ? 'filled' : 'outlined'}
        onClick={() => { onScopeChange('all') }}
        size="small"
        sx={{
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: 500,
          borderRadius: 1.5,
          '&:hover': {
            opacity: 0.8
          }
        }}
      />
    </Box>
  )
}

export default ToggleBadges
